import { Mail, Send } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

const EMAIL = 'eol.servermc@gmail.com';
const TELEGRAM = 'https://t.me/eol_support';

export function ContactsPage() {
  return (
    <div className="mx-auto max-w-4xl px-6 lg:px-12 py-12">
      <h1 className="text-3xl md:text-4xl font-extrabold text-eol-white">Контакты</h1>
      <p className="mt-3 text-eol-desc">
        Связаться с администрацией проекта Empire of Life можно одним из удобных способов.
      </p>

      <h2 className="text-xl font-bold text-eol-white mt-10 mb-4">Для важной связи</h2>
      <div className="grid sm:grid-cols-2 gap-4">
        <Card>
          <CardContent className="pt-6 flex items-start gap-3">
            <Mail className="h-6 w-6 text-eol-pink mt-1 shrink-0" />
            <div className="min-w-0">
              <p className="text-sm text-eol-desc uppercase tracking-wider font-semibold">
                Email
              </p>
              <a
                href={`mailto:${EMAIL}`}
                className="text-eol-white font-semibold break-all hover:text-eol-pink transition"
              >
                {EMAIL}
              </a>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="pt-6 flex items-start gap-3">
            <Send className="h-6 w-6 text-eol-pink mt-1 shrink-0" />
            <div className="min-w-0">
              <p className="text-sm text-eol-desc uppercase tracking-wider font-semibold">
                Telegram-поддержка
              </p>
              <a
                href={TELEGRAM}
                target="_blank"
                rel="noopener noreferrer"
                className="text-eol-white font-semibold hover:text-eol-pink transition"
              >
                @eol_support
              </a>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
